// extracted by mini-css-extract-plugin
export default {"smallError":"lQgWRj0AKQPybMMJ07Vw"};